import { ChevronLeft, ChevronRight } from "lucide-react";

import { cn } from "@/utils/ui";

import LogoFullDark from "@assets/logo/medirect-primary-dark.svg?url";
import LogoIcon from "@assets/logo/medirect-primary-icon.svg?url";
import LogoFull from "@assets/logo/medirect-primary.svg?url";

import { useMe } from "@hooks/queries/use-me";

import { useSidebar } from "../store";

export const LogoHeader = () => {
  const { isExpanded, toggle } = useSidebar();
  // External portals (referrer + provider): the navy sidebar shows a
  // "MEDirect / <portal>" lockup, not the default "Medicolegal Portal" wordmark.
  const { data: me } = useMe();
  const userType = me?.user?.user_type;
  const isProvider = userType === "provider";
  const isPortal = isProvider || userType === "referrer";
  const portalSubtitle = isProvider ? "Provider · ConnectNet" : "Referrer Portal";

  const toggleButton = (
    <button
      type="button"
      aria-label={isExpanded ? "Collapse sidebar" : "Expand sidebar"}
      className={cn(
        "flex size-7 shrink-0 cursor-pointer items-center justify-center rounded-lg border border-border bg-background-white text-foreground-muted transition-colors duration-150",
        "hover:bg-primary/[0.07]",
        "focus-visible:shadow-nav-focus focus-visible:outline-none",
        "dark:border-white/[0.12] dark:bg-white/[0.04] dark:text-foreground-light/70 dark:hover:bg-white/[0.06]"
      )}
      onClick={toggle}
    >
      {isExpanded ? (
        <ChevronLeft className="size-4" />
      ) : (
        <ChevronRight className="size-4" />
      )}
    </button>
  );

  return (
    <div
      className={cn(
        "border-b border-border dark:border-white/[0.08]",
        isExpanded
          ? "flex items-center justify-between gap-2 px-3.5 pb-3 pt-4"
          : "flex flex-col items-center gap-3 px-0 pb-3 pt-4"
      )}
    >
      {isExpanded && isPortal ? (
        <>
          <div className="flex min-w-0 items-center gap-2">
            <img src={LogoIcon} alt="MEDirect" className="h-8 w-auto shrink-0" />
            <div className="min-w-0 text-left leading-tight">
              <div className="text-[15px] font-bold text-white">MEDirect</div>
              <div className="text-[10.5px] font-medium text-[#93A9D9]">
                {portalSubtitle}
              </div>
            </div>
          </div>
          <ChevronLeft className="size-4 shrink-0 text-white/70" />
        </>
      ) : isExpanded ? (
        <>
          {/* Colored logo on the white (light) nav */}
          <img src={LogoFull} alt="MEDirect" className="h-8 w-auto dark:hidden" />
          {/* White logo on the navy (dark) nav */}
          <img
            src={LogoFullDark}
            alt="MEDirect"
            className="hidden h-8 w-auto dark:block"
          />
        </>
      ) : (
        <img src={LogoIcon} alt="MEDirect" className="h-8 w-auto" />
      )}

      {toggleButton}
    </div>
  );
};
